import React, { useState, useEffect } from "react";
import {
  Grid,
  Checkbox,
  TextareaAutosize,
  Typography,
  Button,
  List,
  ListItem,
  makeStyles
} from "@material-ui/core";

import { Link, useHistory, useLocation } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";


/** Local dependencies & Libraries */
import { Imports } from '../../../Imports';

import Services from '../../../Services';
import { paths } from "./path";
import SidebarApplicants from "../../../Components/SidebarApplicants";


// const {
//   employeeStatuses
// } = Imports;

const {
  Storage
} = Services;

// import MobileScreen from './Mobile/Enter-RailRoad-Add';
// import {isMobile} from 'react-device-detect';



// const useStyles = makeStyles((theme) => ({
//   DisplayNone: {
//     display: 'none'
//   },
//   SubmissionProcess: {
//     width: '200px',
//     position: 'absolute',
//     bottom: '2vw',
//     right: '2vw',
//     'font-size': '11px',
//   }
// }));

const Submission = (props) => {


  const location = useLocation();
  const history = useHistory()
  const storage = new Storage();

   

  useEffect(() => {
     
    let user = JSON.parse(localStorage.getItem('user_profile'));
    if (user) {
      var { ApplicantStatusId } = user;
       
      if (props.status !== ApplicantStatusId) {
        history.push(paths[ApplicantStatusId])
      }
    }
  }, [])

  // if (applyToStorage) {

  //   for (let key in applyToStorage) {
  //     const data = applyToStorage[key];

  //     storage.set(key, JSON.stringify(data));
  //   }

  //   const queryParams = new URLSearchParams(location?.state);

  //   if (queryParams.has('applyToStorage'))
  //     queryParams.delete('applyToStorage');
  // }

  // const classes = useStyles();

  const userProfile = JSON.parse(
    localStorage.getItem('user_profile')
  )

  if (userProfile) {
    var {
      ApplicantStatusId
    } = userProfile;
  }

  const submissionStatus = Imports?.employeeStatuses
    ?.find(status => status?.id === ApplicantStatusId);

  const {
    params: {
      status,
      nextStep: linkToUse,
    }
  } = submissionStatus;


  return (
    <Grid container xs={12} className="Liq-Container HRPortal">
      <Grid xs={12} md={2} className="LeftContol" id="LeftContol">
        <SidebarApplicants />
      </Grid>
      <Grid xs={12} md={10} container justify="center" className="PageContent">
        <Grid className="PagesFrame">
          <PageHeader />
          <Grid id="PageTitle">Waiting For HR Approval</Grid>
          <div className="submission_inner">
            <div className="SubmissionTable"><div></div></div>
            <div className="main_cont">
              <>Thank you for applying to TGS, Our HR Team will review your application & get back to you.</>
            </div>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Submission;
